export enum RecordingDisclosure {
  ALWAYS = "ALWAYS",
  WHERE_REQUIRED = "WHERE_REQUIRED",
  NEVER = "NEVER",
}

export const DEFAULT_RECORDING_NOTICE = "This call is being recorded.";

export const RECORDING_DISCLOSURE_OPTIONS = [
  {
    value: RecordingDisclosure.ALWAYS,
    label: "On every recorded call",
    description: "Everyone hears a short notice before the call connects.",
  },
  {
    value: RecordingDisclosure.WHERE_REQUIRED,
    label: "Only where the law requires it",
    description: "Plays only for people in states that require everyone's consent. Other calls stay silent.",
  },
  {
    value: RecordingDisclosure.NEVER,
    label: "Never",
    description: "No notice. Calls with people in states that require everyone's consent are not recorded.",
  },
];
